import { Message } from '../../message';

export class SNGCard extends Message {
    private MESSAGE_NAME: string = 'SNGCard';
    private cardId: number = 0;
    private tourneyTemplateId: number = 0;
    private buyIn: number = 0;
    private tourneyFee: number = 0;
    private buyInType: number = 0;
    private freeRollIdList: any[] | null = null;
    private gameType: number = 0;
    private limitType: number = 0;
    private maxSeats: number = 0;
    private gameSpeed: number = 0;
    private tag: number = 0;
    private imageName: string | null = null;
    private isImageURL: number = 0;
    private gameCurrency: string | null = null;
    private lastPlayed: boolean | null = false;
    private sngGame: number = 0;
    private name: any | null = null;
    private partyPoints: number = 0;
    private uniqueCode: string | null = null;
    private favourite: boolean | null = false;

    getMessageName(): string {
        return this.MESSAGE_NAME;
    }

    constructor();

    constructor(
        reqServerPeerId: number = 0,
        cardId: number = 0,
        tourneyTemplateId: number = 0,
        buyIn: number = 0,
        tourneyFee: number = 0,
        buyInType: number = 0,
        freeRollIdList: any[] | null = null,
        gameType: number = 0,
        limitType: number = 0,
        maxSeats: number = 0,
        gameSpeed: number = 0,
        tag: number = 0,
        imageName: string | null = null,
        isImageURL: number = 0,
        gameCurrency: string | null = null,
        lastPlayed: boolean | null = false,
        sngGame: number = 0,
        name: any | null = null,
        partyPoints: number = 0,
        uniqueCode: string | null = null,
        favourite: boolean | null = false,
    ) {
        super(reqServerPeerId);
        this.cardId = cardId;
        this.tourneyTemplateId = tourneyTemplateId;
        this.buyIn = buyIn;
        this.tourneyFee = tourneyFee;
        this.buyInType = buyInType;
        this.freeRollIdList = freeRollIdList;
        this.gameType = gameType;
        this.limitType = limitType;
        this.maxSeats = maxSeats;
        this.gameSpeed = gameSpeed;
        this.tag = tag;
        this.imageName = imageName;
        this.isImageURL = isImageURL;
        this.gameCurrency = gameCurrency;
        this.lastPlayed = lastPlayed;
        this.sngGame = sngGame;
        this.name = name;
        this.partyPoints = partyPoints;
        this.uniqueCode = uniqueCode;
        this.favourite = favourite;
    }

    getCardId(): number {
        return this.cardId;
    }

    setCardId(cardId: number) {
        this.cardId = cardId;
    }
    getTourneyTemplateId(): number {
        return this.tourneyTemplateId;
    }

    setTourneyTemplateId(tourneyTemplateId: number) {
        this.tourneyTemplateId = tourneyTemplateId;
    }
    getBuyIn(): number {
        return this.buyIn;
    }

    setBuyIn(buyIn: number) {
        this.buyIn = buyIn;
    }
    getTourneyFee(): number {
        return this.tourneyFee;
    }

    setTourneyFee(tourneyFee: number) {
        this.tourneyFee = tourneyFee;
    }
    getBuyInType(): number {
        return this.buyInType;
    }

    setBuyInType(buyInType: number) {
        this.buyInType = buyInType;
    }
    getFreeRollIdList(): any[] | null {
        return this.freeRollIdList;
    }

    setFreeRollIdList(freeRollIdList: any[] | null) {
        this.freeRollIdList = freeRollIdList;
    }
    getGameType(): number {
        return this.gameType;
    }

    setGameType(gameType: number) {
        this.gameType = gameType;
    }
    getLimitType(): number {
        return this.limitType;
    }

    setLimitType(limitType: number) {
        this.limitType = limitType;
    }
    getMaxSeats(): number {
        return this.maxSeats;
    }

    setMaxSeats(maxSeats: number) {
        this.maxSeats = maxSeats;
    }
    getGameSpeed(): number {
        return this.gameSpeed;
    }

    setGameSpeed(gameSpeed: number) {
        this.gameSpeed = gameSpeed;
    }
    getTag(): number {
        return this.tag;
    }

    setTag(tag: number) {
        this.tag = tag;
    }
    getImageName(): string | null {
        return this.imageName;
    }

    setImageName(imageName: string | null) {
        this.imageName = imageName;
    }
    getIsImageURL(): number {
        return this.isImageURL;
    }

    setIsImageURL(isImageURL: number) {
        this.isImageURL = isImageURL;
    }
    getGameCurrency(): string | null {
        return this.gameCurrency;
    }

    setGameCurrency(gameCurrency: string | null) {
        this.gameCurrency = gameCurrency;
    }
    getLastPlayed(): boolean | null {
        return this.lastPlayed;
    }

    setLastPlayed(lastPlayed: boolean | null) {
        this.lastPlayed = lastPlayed;
    }
    getSngGame(): number {
        return this.sngGame;
    }

    setSngGame(sngGame: number) {
        this.sngGame = sngGame;
    }
    getName(): any | null {
        return this.name;
    }

    setName(name: any | null) {
        this.name = name;
    }
    getPartyPoints(): number {
        return this.partyPoints;
    }

    setPartyPoints(partyPoints: number) {
        this.partyPoints = partyPoints;
    }
    getUniqueCode(): string | null {
        return this.uniqueCode;
    }

    setUniqueCode(uniqueCode: string | null) {
        this.uniqueCode = uniqueCode;
    }
    getFavourite(): boolean | null {
        return this.favourite;
    }

    setFavourite(favourite: boolean | null) {
        this.favourite = favourite;
    }
}
